import { Snackbar } from "@material-ui/core";

import React, { useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import SocieteService from "../services/Societe";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ConfigurerBloquerClient = ({
  setOnConfigBlock,
  clientName,
  idSociete,
}) => {
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };


  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnConfigBlock(false);
  };

  const onAddSocieteSeuil = () => {
      SocieteService.blockSociete(getCurrentUserId(),idSociete)
        .then((response) => {
          if (response?.data?.success) {
            setOpenAlert(true);
            setTimeout(setOnConfigBlock(false), 5000);
            setOnConfigBlock(false);
            setOpen(false);
            window.location.reload(false);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText(response?.data?.error);
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    
  };

  return (
    <>
      <div class="modal fade" id="configurer-block-client">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">
                Client : <b>{clientName}</b>
              </h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Etes-vous sûr de bloquer ce client?</label>
                    
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button
                type="button"
                onClick={onAddSocieteSeuil}
                class="btn btn-light"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <Snackbar
          open={openAlert}
          autoHideDuration={2000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert onClose={handleClose} severity="success">
            Ajout avec success !
          </Alert>
        </Snackbar>
      )}

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConfigurerBloquerClient;
